export default "__VITE_ASSET__DUimmqt6__"